import React from 'react';
import { SideSheet, Box, Text, Spacer, Button } from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import { useDispatch } from 'react-redux';
import { queryTransaction } from 'redux/transaction-history/actions';

export const QueryTransactionModal = ({
  current,
  handleCurrent,
  handleModal,
  show,
  loading,
}) => {
  const dispatch = useDispatch();

  return (
    <SideSheet
      width="400px"
      open={show}
      onClose={() => {
        handleCurrent(null);
        handleModal(false);
      }}
    >
      <Box pad="20px 30px 50px">
        <h2 style={{ fontWeight: 500 }}>Transaction Status</h2>

        <Box margin="80px 0 20px">
          <Text size="65px" block color={Theme.PrimaryYellow}>
            <i className="saf-warning"></i>
          </Text>
          <Spacer space="25px" />
          <Text size="14px" bold uppercase block>
            {' '}
            Transaction pending{' '}
          </Text>
          <Spacer space="15px" />
          <Text block>
            Transaction with the payment reference{' '}
            <strong> {current?.reference} </strong> is still pending do try
            checking the status of the traction again
          </Text>
          <Spacer space="50px" />
          <Button
            spaceRight
            iconRight={<i className="flexibull-spin4" />}
            progress={loading}
            onClick={() =>
              dispatch(
                queryTransaction(current?.reference, () => {
                  handleCurrent(null);
                  handleModal(false);
                })
              )
            }
          >
            Try Again
          </Button>
        </Box>
      </Box>
    </SideSheet>
  );
};

QueryTransactionModal.propTypes = {
  current: PropTypes.object,
  loading: PropTypes.bool,
  handleCurrent: PropTypes.func,
  handleModal: PropTypes.func,
  show: PropTypes.bool,
};
